(function(window, document) {
  'use strict';

  function initOrttoForms() {
    var forms = document.querySelectorAll('[data-ortto-form]');

    Array.prototype.forEach.call(forms, function(form) {
      var emailInput = form.querySelector('input[name="email"]');
      var instaInput = form.querySelector('input[name="insta"]');

      if (emailInput) {
        emailInput.setAttribute('placeholder', 'Ton email');
      }

      if (instaInput) {
        instaInput.setAttribute('placeholder', '@ton_insta');
      }
    });
  }

  function initCollectionFilters() {
    var filterGroups = document.querySelectorAll('[data-collection-filters]');

    Array.prototype.forEach.call(filterGroups, function(filterGroup) {
      var targetId = filterGroup.getAttribute('data-collection-target');
      var grid = targetId ? document.getElementById(targetId) : null;
      var buttons = filterGroup.querySelectorAll('[data-filter]');
      var cards;

      if (!grid || !buttons.length) {
        return;
      }

      cards = grid.querySelectorAll('.product-card-collection');

      Array.prototype.forEach.call(buttons, function(button) {
        button.addEventListener('click', function() {
          var filterValue = button.getAttribute('data-filter');

          Array.prototype.forEach.call(buttons, function(nextButton) {
            nextButton.classList.toggle('active', nextButton === button);
          });

          Array.prototype.forEach.call(cards, function(card) {
            if (filterValue === 'all') {
              card.hidden = false;
              return;
            }

            card.hidden = !card.classList.contains('tag-' + filterValue);
          });
        });
      });
    });
  }

  function initGrowthEnhancements() {
    initOrttoForms();
    initCollectionFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGrowthEnhancements, { once: true });
  } else {
    initGrowthEnhancements();
  }
})(window, document);
